<div style="margin: 16px">
	<hot-table [settings]="tableSettings" [data]="data" [columns]="cols"> </hot-table>
	<br />
</div>
